export default __webpack_public_path__ + "static/media/queen.88ae285c.jpg";